export default __webpack_public_path__ + "static/media/det.c4059661.jpeg";